import actionTypes from './action-types'

export const fetchWatchlistCompliance = ({ options }: { options: Record<string, any> }) => {
  return {
    type: actionTypes.ENTITIES_FETCH_BEGIN,
    options,
  }
}
export type FetchShiftBookingsAction = ReturnType<typeof fetchWatchlistCompliance>
